export const introduce = {
  text: `### 指标原理
  + 该指标统计了Token在Uniswap上的交易总数`,
  height: 1290,
};